export const ProductActionTypes = {
  API_RESPONSE_SUCCESS: "@@product/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR: "@@product/API_RESPONSE_ERROR",
  PRODUCT_LIST: "@@product/PRODUCT_LIST",
};
